import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { getIconHostUrl } from './utils.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["category", "params", "size"];
var IconHost = function IconHost(_ref) {
  var _ref$category = _ref.category,
    category = _ref$category === void 0 ? "content-icons-v2" : _ref$category,
    params = _ref.params,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  return /*#__PURE__*/jsx("img", _objectSpread({
    src: getIconHostUrl(category, params),
    alt: "".concat(t("IconHost.categoryIcon", {
      category: category
    })),
    "aria-hidden": true,
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24
  }, rest));
};
IconHost.displayName = "IconHost";

export { IconHost };
